import { EPOCUS_TEXT_SECONDARY } from "./epocus-palette";

// Semantic QA score thresholds — shared by me/page and program/page
export const SCORE_GOOD = "#10B981";
export const SCORE_OK = "#F59E0B";
export const SCORE_LOW = "#EF4444";

export const getScoreColor = (score: string): string => {
  if (score === "—") return EPOCUS_TEXT_SECONDARY;
  const n = parseFloat(score);
  if (n >= 4.0) return SCORE_GOOD;
  if (n >= 3.5) return SCORE_OK;
  return SCORE_LOW;
};
